<section>
  <div class="container">
    <div class="row mt-2 border Page-Header">
      <h6 class="HeadContent">
        <span class="p-2"
          >Admin - Course Management - {{ examAgencyMode }} Exam Agency</span
        >
      </h6>
    </div>

    <form [formGroup]="addEditExamAgency" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <!-- Exam Agency Name -->
            <div class="col-md-2">
              <div class="d-flex my-2 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Exam Agency Name</div>
              </div>
            </div>
            <div class="col-md-4 my-2">
              <div>
                <input
                  type="text"
                  class="form-control form-control-sm input-txt"
                  formControlName="Exam_Agency_Name"
                  [ngClass]="
                    getError('Exam_Agency_Name') ? 'red-border-required' : ''
                  "
                />
              </div>
            </div>

            <!-- AGency Status -->
            <div class="col-md-2">
              <div class="d-flex my-2 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Agency Status</div>
              </div>
            </div>
            <div class="col-md-4 my-2">
              <select
                formControlName="Exam_Agency_Status_Type_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="
                  getError('Exam_Agency_Status_Type_Code')
                    ? 'red-border-required'
                    : ''
                "
              >
                <option hidden>Choose Agency Status</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of examAgencyStatusType"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
          </div>

          <!--  Website -->
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0">Website</div>
                <!-- <div class="p-0 label-red">*</div> -->
              </div>
            </div>
            <div class="col-md-10 my-1">
              <div>
                <input
                  formControlName="Website_Address"
                  type="text"
                  class="form-control form-control-sm input-txt"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0">Primary Phone Number</div>
                <!-- <div class="p-0 label-red">*</div> -->
              </div>
            </div>
            <div class="col-md-2 my-1">
              <select
                formControlName="Primary_Phone_Country_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="phoneNumberError.code1 ? 'red-border-required' : ''"
                (change)="phoneNumberError.code1 = false"
              >
                <option hidden>Choose Country Code</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of phoneCountryCode"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
            <div class="col-md-4 my-1">
              <div>
                <input
                  [ngClass]="
                    phoneNumberError.phone1 ? 'red-border-required' : ''
                  "
                  formControlName="Primary_Phone_Number"
                  type="number"
                  maxlength="10"
                  (paste)="(false)"
                  (keypress)="preventEnteringString($event, 10)"
                  (keyup)="phoneNumberError.phone1 = false"
                  class="form-control form-control-sm input-txt"
                />
              </div>
            </div>
          </div>

          <!-- Secondary Phone Number -->
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0">Secondary Phone Number</div>
                <!-- <div class="p-0 label-red">*</div> -->
              </div>
            </div>
            <div class="col-md-2 my-1">
              <select
                formControlName="Secondary_Phone_Country_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="phoneNumberError.code2 ? 'red-border-required' : ''"
                (change)="phoneNumberError.code2 = false"
              >
                <option hidden>Choose Country Code</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of phoneCountryCode"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
            <div class="col-md-4 my-1">
              <div>
                <input
                  [ngClass]="
                    phoneNumberError.phone2 ? 'red-border-required' : ''
                  "
                  formControlName="Secondary_Phone_Number"
                  type="number"
                  (keypress)="preventEnteringString($event, 10)"
                  (paste)="(false)"
                  (keyup)="phoneNumberError.phone2 = false"
                  class="form-control form-control-sm input-txt"
                />
              </div>
            </div>
          </div>

          <!-- Address -->

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Address</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="Address_Line_1"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  placeholder="Address Line 1"
                  [ngClass]="
                    getError('Address_Line_1') ? 'red-border-required' : ''
                  "
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1">
                <!-- <div class="p-0"></div>
                <div class="p-0 label-red">*</div> -->
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="Address_Line_2"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  placeholder="Address Line 2"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1">
                <!-- <div class="p-0"></div>
                <div class="p-0 label-red">*</div> -->
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="Address_Line_3"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  placeholder="Name of the delivery post office"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">City</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="City_Name"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  [ngClass]="getError('City_Name') ? 'red-border-required' : ''"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Pin Code</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <input
                  formControlName="Postal_Code"
                  type="text"
                  class="form-control form-control-sm input-txt"
                  [ngClass]="
                    getError('Postal_Code') ? 'red-border-required' : ''
                  "
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Country</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <select
                formControlName="Country_Code"
                class="form-control form-control-sm inputfield-txt"
                (change)="countryChange()"
                [ngClass]="
                  getError('Country_Code') ? 'red-border-required' : ''
                "
              >
                <option hidden>Choose Country</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of countryCode"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">State</div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <select
                formControlName="State_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="getError('State_Code') ? 'red-border-required' : ''"
              >
                <option hidden>Choose State</option>
                <option
                  class="border-bottom"
                  *ngFor="let code of stateCode"
                  [value]="code.Code"
                >
                  {{ code.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <div class="d-flex my-1 flex-row-reverse">
                <div class="p-0">Description</div>
                <div class="p-0 label-red"></div>
              </div>
            </div>
            <div class="col-md-6 my-1">
              <div>
                <textarea
                  formControlName="Agency_Description"
                  class="form-control form-control-sm input-txt"
                  rows="4"
                  cols="50"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12"></div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div
                class="mb-2 my-3 d-flex justify-content-center"
                *ngIf="examAgencyMode !== 'View'"
              >
                <span>
                  <button
                    class="btn btn-sm bl-btn"
                    [disabled]="addEditExamAgency.invalid"
                  >
                    <span class="text-light">SAVE</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    (click)="clear()"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
              <div
                class="mb-2 my-3 d-flex justify-content-center"
                *ngIf="examAgencyMode === 'View'"
              >
                <span>
                  <button class="btn btn-sm bl-btn" [disabled]="true">
                    <span class="text-light">SAVE</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    [disabled]="true"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
